import * as jsxRuntime from "C:\\Eidos!!!\\handvaerksgave3.0\\78-eido-3.0-handvaerkshave\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment